/**
 * Named z-index tokens for the site's fixed/floating chrome — the elements
 * that can visually stack against each other regardless of which page
 * they're on: the sticky header, the homepage carousel's own arrow buttons,
 * "Book Your Resort", WhatsApp, and the AI chat widget.
 *
 * This intentionally does NOT cover every z-index in the codebase — cards,
 * badges, and other locally-scoped stacking contexts inside a single
 * component don't compete with anything outside themselves and are left as
 * plain Tailwind classes. Only the values that were already being reasoned
 * about *relative to each other* (see StayBookingTab.tsx's own comment)
 * are centralized here, so that reasoning lives in one place instead of
 * being re-derived from scattered magic numbers.
 *
 * Order, lowest to highest: header sits under everything; the homepage
 * carousel's arrows sit just above "Book Your Resort" so they stay clickable
 * on the rare scroll position where the two coincide; WhatsApp and the AI
 * chat widget sit on top of both, since they're global overlays. The
 * install / alerts popup sits above those: it is short-lived and the × must
 * stay tappable where it overlaps the WhatsApp or chat button.
 */
export const Z_HEADER = "z-[60]";
export const Z_CAROUSEL_ARROW = "z-50";
export const Z_BOOK_STAY_TAB = "z-40";
export const Z_FLOATING_WIDGET = "z-[80]";
export const Z_OFFER_POPUP = "z-[90]";
/** Search suggestions under a search box: above everything while typing,
 *  including the header the desktop box sits in and the mobile menu. */
export const Z_SEARCH_SUGGEST = "z-[100]";
